import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from '@mui/material';

interface CompanyTableSkeletonProps {
  rows?: number;
  columns?: number;
}

export const CompanyTableSkeleton: React.FC<CompanyTableSkeletonProps> = ({
  rows = 8,
  columns = 7,
}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Empresa</TableCell>
            <TableCell>CNPJ</TableCell>
            <TableCell>Status</TableCell>
            {columns >= 8 && <TableCell>Upload trial</TableCell>}
            {columns >= 9 && <TableCell>Dados do cadastro</TableCell>}
            <TableCell>Clientes</TableCell>
            <TableCell>IA</TableCell>
            <TableCell>Storage</TableCell>
            <TableCell align="right">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, index) => (
            <TableRow key={index} hover>
              <TableCell>
                <Skeleton variant="text" width="80%" height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="70%" height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={70} height={24} />
              </TableCell>
              {columns >= 8 && (
                <TableCell>
                  <Skeleton variant="text" width={140} height={24} />
                </TableCell>
              )}
              {columns >= 9 && (
                <TableCell>
                  <Skeleton variant="text" width={140} height={24} />
                </TableCell>
              )}
              <TableCell>
                <Skeleton variant="text" width={140} height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={140} height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={140} height={24} />
              </TableCell>
              <TableCell align="right">
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                  <Skeleton variant="circular" width={32} height={32} />
                  <Skeleton variant="circular" width={32} height={32} />
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
